// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CircleButton } = require('client-v2/common/components/buttons')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('TooltipBubble')

function TooltipBubble(props) {
  return tag('div', {
    className: bem.block({
      [props.tooltipKey]: !!props.tooltipKey,
      dismissed: !!props.isDismissed,
      placement: props.popperPlacement
    }),
    ref: props.popperRef,
    style: props.popperStyle,
    onClick: props.onDismiss
  },
    tag(CircleButton, {
      className: bem.element('close-button'),
      onClick: props.onDismiss
    }),
    tag('div', {
      className: bem.element('arrow', {
        placement: props.popperPlacement
      }),
      ref: props.arrowRef,
      style: props.arrowStyle
    }),
    props.children
  )
}

TooltipBubble.propTypes = {
  children: PropTypes.node.isRequired,
  // Values
  isDismissed: PropTypes.bool,
  tooltipKey: PropTypes.string,
  // Popper.JS props
  arrowRef: PropTypes.func.isRequired,
  arrowStyle: PropTypes.object.isRequired,
  popperPlacement: PropTypes.string,
  popperRef: PropTypes.func.isRequired,
  popperStyle: PropTypes.object.isRequired,
  // Callbacks
  onDismiss: PropTypes.func.isRequired
}

TooltipBubble.renderChildren = function (title, body) {
  return tag([
    TooltipBubble.renderTitle(title),
    TooltipBubble.renderBody(body)
  ])
}

TooltipBubble.renderTitle = function (...titleChildren) {
  if (titleChildren.length === 1 && !titleChildren[0]) {
    return null
  }
  return tag('div', {
    className: bem.element('title')
  },
    ...titleChildren
  )
}

TooltipBubble.renderBody = function (...bodyChildren) {
  if (bodyChildren.length === 1 && !bodyChildren[0]) {
    return null
  }
  return tag('div', {
    className: bem.element('body')
  },
    ...bodyChildren
  )
}

module.exports = TooltipBubble
